import script from "./ConstructionTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ConstructionTable.vue?vue&type=script&setup=true&lang=js"

import "./ConstructionTable.vue?vue&type=style&index=0&id=43092571&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43092571"]])

export default __exports__